import { render, staticRenderFns } from "./billForProprietor.vue?vue&type=template&id=4f049ef6&scoped=true"
import script from "./billForProprietor.vue?vue&type=script&lang=js"
export * from "./billForProprietor.vue?vue&type=script&lang=js"
import style0 from "./billForProprietor.vue?vue&type=style&index=0&id=4f049ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f049ef6",
  null
  
)

export default component.exports